import { useSearchParams } from 'react-router-dom';

export const useGetParams = () => {
  const [searchParams] = useSearchParams();
  let phoneNumber = searchParams.get('phoneNumber');

  if (phoneNumber) {
    let textNumber;
    textNumber = phoneNumber
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/"/g, '&quot;');
    if (textNumber[0].match(/\s/)) {
      textNumber = textNumber.replace(/\s/, '+');
    }
    phoneNumber = textNumber;
  }

  return {
    user: searchParams.get('user') || null,
    bg: searchParams.get('bg') || null,
    phoneNumber,
    title: searchParams.get('title'),
    socials: searchParams.get('socials'),
    qrCode: searchParams.get('qrCode'),
    sizeQR: searchParams.get('sizeQR') || '20',
    paddingQR: searchParams.get('paddingQR') || '0',
    phoneNumberFontSize: searchParams.get('phoneNumberFontSize') || '4.8',
    titleFontSize: searchParams.get('titleFontSize') || '4.8',
    questionFontSize: searchParams.get('questionFontSize') || '4',
    answerFontSize: searchParams.get('answerFontSize') || '3.6',
    varNumFontSize: searchParams.get('varNumFontSize') || '5',
  };
};
